module.exports = __webpack_public_path__ + "img/edit.e2aa22a8.svg";